import React, { useState } from "react";
import { Node } from "./canvas-utils";
import { Button, Input } from "@mui/material";

interface NodeTextFormProps {
  node: Node | null;
  onSave: (text: string) => void;
}

const NodeTextForm = ({ node, onSave }: NodeTextFormProps) => {
  const [text, setText] = useState(node?.text || "");

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSave(text);
  };

  return (
    <div>
      <form onSubmit={handleSubmit} className="flex flex-col">
        <Input
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          fullWidth
          multiline
          minRows={4}
        />

        <div className="mt-8">
          <Button variant="contained" type="submit" fullWidth>
            Сохранить
          </Button>
        </div>
      </form>
    </div>
  );
};

export default NodeTextForm;
